import { useStore } from '@/store'
import { computed } from '@vue/composition-api'

export default function useUser() {
  const store = useStore()

  const user = computed(() => {
    return store.state.user.data
  })

  const setUserData = (data) => {
    store.commit('user/setData', data)
  }

  const goToDefaultUserPage = () => {
    return store.dispatch('user/goToDefaultPage')
  }

  return {
    user,
    setUserData,
    goToDefaultUserPage,
  }
}
